import { render, staticRenderFns } from "./BetonCard.vue?vue&type=template&id=f367069c&scoped=true&"
import script from "./BetonCard.vue?vue&type=script&lang=js&"
export * from "./BetonCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f367069c",
  null
  
)

export default component.exports